<template>
  <div class="results-fast-download">
    <modal
      ref="fastDownload"
      template="neutral"
      title="Download de resultados recentes"
      ref-name="fastDownload"
      :icon-enabled="false"
      :close-button-enabled="true"
      class="fast-results modals"
    >
      <p>
        Temos resultados de exames provenientes de cadastro manual e importados via
        integração. Quais deseja baixar?
      </p>

      <div class="button-container">
        <md-button
          id="btnModalExportXMLOnlyOriginManual"
          class="btn btn-nonenary cards-filter-container__filter-button"
          @click="buildParamsForXmlviaModal({ isIntegrated: false })"
        >
          <md-icon md-src="/static/images/icon-download-arrow.svg" />
          Somente Manuais
        </md-button>
        <md-button
          class="btn btn-nonenary cards-filter-container__filter-button cards-filter-container__filter-button-right"
          @click="buildParamsForXmlviaModal({ isIntegrated: ALL_RESULTS_ORIGIN })"
        >
          <md-icon md-src="/static/images/icon-download-arrow.svg" />
          Manuais + Integrados
        </md-button>
        <md-button
          id="btnModalExportXMLOnlyIntegrated"
          class="btn btn-primary cards-filter-container__filter-button cards-filter-container__filter-button-right"
          @click="buildParamsForXmlviaModal({ isIntegrated: true })"
        >
          <md-icon md-src="/static/images/icon-download-arrow.svg" />
          Somente Integrados
        </md-button>
      </div>
    </modal>

    <transition name="transition">
      <div
        v-if="
          displayTitle &&
          (getResultStatistics.resultsNewCount > 0 ||
            getResultStatistictsLoadingStatus === 'STATUS_INITIAL')
        "
        class="results-main-filter__title"
      >
        <p>
          {{ title }}
        </p>
      </div>
    </transition>

    <div class="cards-filter-container">
      <transition
        name="fade"
        mode="out-in"
      >
        <result-loading-card
          v-if="getResultStatistictsLoadingStatus === 'STATUS_INITIAL'"
        />
        <result-warning-card
          v-else-if="
            displayNoNewsResultsWarning && getResultStatistics.resultsNewCount === 0
          "
          id="noResultsWarning"
          color="green"
          icon="success"
          title="Todos os resultados recentes já foram exportados"
          :dismiss-button-visible="false"
          :text="'Liberados nos últimos ' + daysForStatistics + ' dias'"
        />

        <result-download-card
          v-else-if="
            displayNewResultsDownloadBox && getResultStatistics.resultsNewCount > 0
          "
          id="downloadCardResults"
          title="Resultados Recentes"
          :text="'Últimos ' + daysForStatistics + ' dias, não exportados'"
          :total-results="getResultStatistics.resultsNewCount"
          @click.native="openFastDownloadModal()"
        />
      </transition>
      <transition
        name="transition"
        mode="out-in"
      >
        <result-warning-card
          v-if="displayOldResultsWarning && getResultStatistics.resultsOldCount > 0"
          id="thereAreOldResults"
          title="Resultados Antigos"
          :text="'Prontos há mais de ' + daysForStatistics + ' dias, não exportados'"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import ResultLoadingCard from './Cards/Loading'
import ResultDownloadCard from './Cards/Download'
import ResultWarningCard from './Cards/Warning'
import { mapGetters, mapActions } from 'vuex'
import Moment from 'moment'
import { RESULTS_DATE_TYPE_RESULT_DATE } from '@/enums'
import notify from '../../../api/notification'

const ALL_RESULTS_ORIGIN = null

export default {
  name: 'ResultsFastDownload',
  components: {
    'result-loading-card': ResultLoadingCard,
    'result-download-card': ResultDownloadCard,
    'result-warning-card': ResultWarningCard,
  },
  props: {
    daysForStatistics: {
      type: Number,
      default: 4,
    },
    title: {
      type: String,
      default: 'Download rápido',
    },
    displayTitle: {
      type: Boolean,
      default: true,
    },
    displayNewResultsDownloadBox: {
      type: Boolean,
      default: true,
    },
    displayNoNewsResultsWarning: {
      type: Boolean,
      default: true,
    },
    displayOldResultsWarning: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters([
      'getResultStatistictsLoadingStatus',
      'getResultStatistics',
      'profile',
    ]),
  },
  created() {
    this.resetResultsStatistics()
    this.updateResultsStatistics(this.daysForStatistics)
  },
  methods: {
    ...mapActions([
      'exportResultByFilter',
      'updateResultsStatistics',
      'resetResultsStatistics',
      'selectResultList',
    ]),
    openFastDownloadModal() {
      if (!this.profile.defaulter) {
        if (
          this.getResultStatistics.resultsHasManual &&
          this.getResultStatistics.resultsHasIntegrated
        ) {
          this.$refs.fastDownload.open()
          this.submitEventToAnalytics(
            'Download rápido - abrir modal com opções de origem manual + integrado'
          )
        } else {
          this.buildParamsForXmlviaModal({ isIntegrated: ALL_RESULTS_ORIGIN })
          this.submitEventToAnalytics(
            'Download rápido - download direto sem modal, pois não há variação da origem dos resultados'
          )
        }
      } else {
        notify({
          title: 'AVISO:',
          message:
            'Acesso bloqueado: Entre em contato com o time de atendimento através do 0800 643 8100 ou pelo e-mail: cobranca@dasa.com.br',
        })
      }
    },
    closeFastDownloadModal() {
      this.$refs.fastDownload.close()
    },
    buildParamsForXmlviaModal({ isIntegrated }) {
      this.selectResultList({
        startDate: Moment(new Date()).subtract(this.daysForStatistics, 'days').toDate(),
        endDate: Moment(new Date()).toDate(),
        exported: false,
        dateType: RESULTS_DATE_TYPE_RESULT_DATE,
        integrated: isIntegrated,
      })
      this.downloadXml()
    },
    downloadXml() {
      this.exportResultByFilter().then(downloadLink => {
        if (downloadLink) {
          document.body.appendChild(downloadLink)
          downloadLink.click()

          let self = this
          this.resetResultsStatistics()
          this.$nextTick(function () {
            self.updateResultsStatistics(this.daysForStatistics)
          })
        }
      })
      this.closeFastDownloadModal()
    },
    submitEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Resultados - Filtro',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
  },
}
</script>

<style lang="scss">
@import '../../../../static/stylesheets/variables';

.results-fast-download {
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
    opacity: 0;
  }

  .transition-enter-active {
    transition: opacity 0.5s;
    transition-delay: 0.5s;
  }
  .transition-leave-active {
    transition: opacity 0.5s;
  }
  .transition-enter, .transition-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
    opacity: 0;
  }

  @keyframes animateArrow {
    0% {
      transform: translateY(-3px);
    }
    100% {
      transform: translateY(1px);
    }
  }
}

.fast-results.modals .md-dialog {
  .button-container {
    padding-top: 2em;
    display: flex;
    justify-content: space-between;
  }

  .btn-nonenary {
    .md-icon {
      > svg .color {
        fill: $brand-primary;
        transition: 0.6s;
      }
    }

    &:hover .md-icon > svg .color {
      fill: white;
      transition: 0.6s;
    }
  }
}
</style>
